<template>
    <div class="youtube-player">
        <div class="youtube-container" v-show="doMount">
            <!-- Only render when youTubeId is available, and use a dynamic key to force re-render -->
            <YouTube
                className="ytplayerComponent"
                :key="'key'+youtubeKey"
                :src="youTubeFullSource()"
                :vars="youtubeParameters"
                width="100%"
                height="100%"
                @ready="onReady"
                @state-change="onStateChange"
                ref="youtube"
            />
        </div>
    </div>
</template>
<script>
import YouTube from 'vue3-youtube'
import {mapState} from 'vuex'

export default {
    name: "YouTubeCustom",
    components: {
        YouTube
    },
    props: {
        youTubeId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            doMount: false,
            youtubeKey: 1,
            youtubeParameters: {
                rel: 0,
                controls: 1,
                modestbranding: 1,
                autohide: 1,
                playsinline: 1,
                enablejsapi: 1,
            },
        }
    },
    mounted() {
        console.log('a', this.youTubeFullSource())
        setTimeout(this.rekey, 100)
    },
    beforeUnmount() {
      this.doMount = false
    },
    computed: {
        ...mapState({
            youTubeIsClickable: state => state.youTubeIsClickable,
        }),

    },
    watch: {
    },
    methods: {
        rekey() {
            this.doMount = true
            this.youtubeKey++
        },
        onReady() {
            this.$refs.youtube.playVideo()
            // Callback when the YouTube player is ready
        },
        youTubeFullSource() {
            return `https://www.youtube.com/watch?v=${this.youTubeId}`
        },
        playVideo() {
            if (this.$refs.youtube) {
                try {
                    this.$refs.youtube.playVideo()
                } catch (error) {
                    console.log('Error playing video:', error)
                }
            }
        },
        onStateChange() {
            let playerState = this.$refs.youtube.getPlayerState()
            switch (playerState) {
                case -1: // unstarted
                    break
                case 0: // ended
                    break
                case 1: // playing
                    break
                case 2: // paused
                    break
                case 3: // buffering
                    break
                case 5: // video cued
                    break
            }
        },
    },
}
</script>
